import React from 'react'
import Topbar from '../../Home/Mainhomeone/Topbar'
import Header from '../../Globle/Header1'
import Navigation from '../../Home/Mainhomeone/Navigation'
import Breadecrumb from '../../Globle/Breadecrumb'
import BreadCrumbimage from '../Mainshop/BreadCrumbImage'
import Footer1 from '../../Globle/Footer1'
import FillterDetails from '../Mainsidebarshop1/FillterDetails'

const Main = () => {
    return (
        <>
            <Topbar />
            <Header />
            <Navigation />
            <Breadecrumb title='Shop' />
            <BreadCrumbimage />
            <FillterDetails />
            <Footer1 />
        </>
    )
}

export default Main
